/** LLMサービス種類*/
export enum LLM_TYPE {
  /** OpenAI */ OPEN_AI = 1,
  /** Gemini */ GEMINI = 2,
}
